import React, { Component } from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import { API_URL, defaultAdvancedSearchFilter } from 'config.jsx';
import SearchForm from './SearchForm';
import SearchResults from './SearchResults';

class Search extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      hasSearchedAtleastOnce: false,
    };
    this.getHttpRequestUrl = this.getHttpRequestUrl.bind(this);
    this.getSearchResult = this.getSearchResult.bind(this);
    this.changePage = this.changePage.bind(this);
    this.setActiveElephant = this.setActiveElephant.bind(this);
    this.getAdvancedSearchResults = this.getAdvancedSearchResults.bind(this);
    this.addFilter = this.addFilter.bind(this);
    this.removeFilter = this.removeFilter.bind(this);
    this.updateFilter = this.updateFilter.bind(this);
    this.clearFilters = this.clearFilters.bind(this);
    this.handleSearchParameterChange = this.handleSearchParameterChange.bind(this);
  }

  getSearchResult(searchParameter) {
    const { setSearchResult, setCurrentPage, setUsingAdvancedSearch } = this.props;
    setSearchResult({
      results: [],
      previous: null,
      next: null,
      count: 0,
    });
    setCurrentPage(0);
    this.setState({
      loading: true,
      searchParameters: [],
    });
    axios.get(`${API_URL}elephants/`, {
      params: {
        search: searchParameter,
      },
    })
      .then((response) => {
        setSearchResult(response.data);
        setUsingAdvancedSearch(false);
        this.setState({
          loading: false,
          hasSearchedAtleastOnce: true,
        });
      })
      .catch(() => {
        throw new Error('error in basic search');
      })
      .finally(() => this.setState({ loading: false }));
  }

  getAdvancedSearchResults(searchParameters) {
    const { setSearchResult, setCurrentPage, setUsingAdvancedSearch } = this.props;
    setSearchResult({
      results: [],
      previous: null,
      next: null,
      count: 0,
    });
    setCurrentPage(0);
    this.setState({
      loading: true,
      searchParameters,
    });
    const data = searchParameters;
    const config = {
      headers: {
        'content-type': 'application/json',
      },
    };
    axios.post(`${API_URL}search/search/`, data, config)
      .then((response) => {
        setSearchResult(response.data);
        setUsingAdvancedSearch(true);
        this.setState({
          loading: false,
          hasSearchedAtleastOnce: true,
        });
      })
      .catch(() => {
        throw new Error('error in advanced search');
      })
      .finally(() => this.setState({ loading: false }));
  }

  getHttpRequestUrl(page) {
    const { searchResult, currentPage } = this.props;
    if (page - currentPage > 0) return searchResult.next;
    return searchResult.previous;
  }

  setActiveElephant(elephantId) {
    const { setActiveElephant } = this.props;
    setActiveElephant(elephantId);
  }

  changePage(page) {
    const { searchParameters } = this.state;
    const {
      searchResult, setSearchResult, setCurrentPage, usingAdvancedSearch,
    } = this.props;
    const searchUrl = (this.getHttpRequestUrl(page));
    setSearchResult({
      results: [],
      previous: null,
      next: null,
      count: searchResult.count,
    });
    this.setState({
      loading: true,
    });
    if (usingAdvancedSearch) {
      const data = searchParameters;
      const config = {
        headers: {
          'content-type': 'application/json',
        },
      };
      axios.post(searchUrl, data, config)
        .then((response) => {
          setSearchResult(response.data);
          this.setState({ loading: false });
        })
        .catch(() => {
          throw new Error('error in advanced search pagination');
        })
        .finally(() => this.setState({ loading: false }));
    } else {
      axios.get(searchUrl)
        .then((response) => {
          setSearchResult(response.data);
          this.setState({ loading: false });
        })
        .catch(() => {
          throw new Error('error in basic search pagination');
        })
        .finally(() => this.setState({ loading: false }));
    }
    setCurrentPage(page);
  }

  addFilter() {
    const { advancedSearchFilters, setAdvancedSearchFilters } = this.props;
    const newIndex = advancedSearchFilters[advancedSearchFilters.length - 1].index + 1;
    const filter = {
      ...defaultAdvancedSearchFilter, index: newIndex,
    };
    const updatedFilters = [...advancedSearchFilters, filter];
    setAdvancedSearchFilters(updatedFilters);
  }

  removeFilter(index) {
    const { advancedSearchFilters, setAdvancedSearchFilters } = this.props;
    const filteredadvancedSearchFilters = advancedSearchFilters
      .filter(filter => filter.index !== index);
    setAdvancedSearchFilters(filteredadvancedSearchFilters);
  }

  updateFilter(updatedFilter) {
    const { advancedSearchFilters, setAdvancedSearchFilters } = this.props;
    const filterIndex = advancedSearchFilters
      .findIndex(filter => filter.index === updatedFilter.index);
    advancedSearchFilters[filterIndex] = updatedFilter;
    const updatedFilters = [...advancedSearchFilters];
    updatedFilters[filterIndex] = updatedFilter;
    setAdvancedSearchFilters(updatedFilters);
  }

  clearFilters() {
    const { setAdvancedSearchFilters } = this.props;
    const filters = [
      {
        ...defaultAdvancedSearchFilter, index: 0,
      },
    ];
    setAdvancedSearchFilters(filters);
  }

  handleSearchParameterChange(event) {
    const { setSearchParameter } = this.props;
    setSearchParameter(event.target.value);
  }

  render() {
    const {
      loading,
      hasSearchedAtleastOnce,
    } = this.state;
    const {
      searchAttributes,
      advancedSearchFilters,
      searchParameter,
      searchResult,
      currentPage,
    } = this.props;
    return (
      <React.Fragment>
        <SearchForm
          getSearchResult={this.getSearchResult}
          searchAttributes={searchAttributes}
          getAdvancedSearchResults={this.getAdvancedSearchResults}
          advancedSearchFilters={advancedSearchFilters}
          addFilter={this.addFilter}
          removeFilter={this.removeFilter}
          updateFilter={this.updateFilter}
          clearFilters={this.clearFilters}
          searchParameter={searchParameter}
          handleSearchParameterChange={this.handleSearchParameterChange}
        />
        <SearchResults
          searchResult={searchResult}
          loading={loading}
          currentPage={currentPage}
          changePage={this.changePage}
          setActiveElephant={this.setActiveElephant}
          hasSearchedAtleastOnce={hasSearchedAtleastOnce}
        />
      </React.Fragment>
    );
  }
}

Search.defaultProps = {
  usingAdvancedSearch: false,
  currentPage: 0,
};

Search.propTypes = {
  setActiveElephant: PropTypes.func.isRequired,
  searchAttributes: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  advancedSearchFilters: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  searchParameter: PropTypes.string.isRequired,
  searchResult: PropTypes.shape().isRequired,
  setSearchResult: PropTypes.func.isRequired,
  currentPage: PropTypes.number,
  setCurrentPage: PropTypes.func.isRequired,
  usingAdvancedSearch: PropTypes.bool,
  setUsingAdvancedSearch: PropTypes.func.isRequired,
  setAdvancedSearchFilters: PropTypes.func.isRequired,
  setSearchParameter: PropTypes.func.isRequired,
};

export default Search;



// WEBPACK FOOTER //
// ./src/components/search/Search.jsx